<div [matTooltip]="(verified ? 'verification.id.verified' : 'verification.id.notVerified') | translate"
     matTooltipPosition="below">
     <button mat-icon-button (click)="editVerificationStatus()">
       <mat-icon [style.color]="verified ? '#4caf50' : '#f44336'">
         {{ verified ? 'verified_user' : 'gpp_bad' }}
       </mat-icon>
     </button>
</div>